// Central business configuration — single source of truth for commercial data
export const BUSINESS = {
  name: 'EpoxyArt33',
  profileName: 'EpoxyArt33 Concrete Coatings & Surface Solutions',
  phone: '(239) 276-1462',
  phoneRaw: '2392761462',
  emails: {
    contact: 'luis@epoxyart33.com',
    estimates: 'estimates@epoxyart33.com',
  },
  address: {
    street: '160 15th St SW',
    city: 'Naples',
    state: 'FL',
    zip: '34117',
  },
  hours: 'Mon–Sat: 7:00 AM – 6:00 PM',
  licenses: 'Florida Licensed & Insured',
  certifications: ['OSHA 30-Hour Safety Certified', 'SAM.GOV Registered'],
  serviceAreas: ['Naples', 'Marco Island', 'Bonita Springs', 'Estero', 'Fort Myers', 'Cape Coral', 'Lehigh Acres', 'Lakewood Ranch', 'Bradenton', 'Sarasota'],
  social: {
    facebook: 'https://www.facebook.com/profile.php?id=61559227113329',
    instagram: 'https://instagram.com/epoxy_art33',
  },
  googleReviews: 'https://g.page/r/CS9tqGDQygtDEBM/review',
  whatsapp: 'https://wa.me/12392761462',
  government: {
    uei: 'ZJG7DEABBA77',
    cageCode: '18ND4',
    naicsCodes: ['238330 — Flooring Contractors', '238390 — Other Building Finishing Contractors'],
    samRegistered: true,
    insuranceLimits: 'Certificate of Insurance available upon request',
    bondingCapacity: 'Discussed per project scope',
    serviceArea: 'Southwest Florida — Collier, Lee, Manatee & Sarasota County',
    projectCapacity: 'Single-phase and multi-phase installations up to 100,000+ sq ft',
    safetyDocs: 'OSHA 30-certified crew — safety documentation available upon request',
    rfqEmail: 'luis@epoxyart33.com',
  },
  stats: {
    projects: 500,
    happyClients: 500,
    yearsExperience: 5,
    googleRating: 5.0,
  },
  warranty: {
    residential: 'Lifetime Warranty',
    commercial: '20-Year Warranty',
  },
  pricing: {
    flake: '$6-10/sq ft',
    metallic: '$8-15/sq ft',
    quartz: '$10-15/sq ft',
    commercial: '$4-12/sq ft',
    industrial: '$4-10/sq ft',
    urethaneCement: '$12-20/sq ft',
    polishedConcrete: '$5-12/sq ft',
    driveway: '$6-12/sq ft',
    waterproofing: '$10-20/sq ft',
  },
};
